export var SERVER = 'server';
export var CLOUD = 'cloud';
export var DATA_CENTER = 'dataCenter';